import { createAction } from 'redux-actions';
import { reduxKey } from './constants';

export const searchTags = createAction(
  `${reduxKey}.SEARCH_TAGS`,
  (query: string) => ({ query })
);
export const searchSuccess = createAction(
  `${reduxKey}.SEARCH_SUCCESS`,
  tags => ({ tags })
);
export const searchFailure = createAction(
  `${reduxKey}.SEARCH_FAILURE`,
  () => ({})
);
